import {
  REQUEST_CCP,
  RECEIVE_CCP,
  CCP_FAILED
} from '../actions/types';

function ccpRequest(state = {}, action) {
  switch(action.type) {
    case RECEIVE_CCP:
      return Object.assign({}, state, {
        isFetching: false,
        ccp: action.ccp
      });
    case REQUEST_CCP:
      return Object.assign({}, state, {
        isFetching: true,
        ccp: []
      });
    case CCP_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        ccp: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default ccpRequest;
